module.exports = __webpack_public_path__ + "img/SA.ec114d74.png";